import { render, staticRenderFns } from "./PlatinMarketKategori.vue?vue&type=template&id=1a574242&scoped=true"
import script from "./PlatinMarketKategori.vue?vue&type=script&lang=js"
export * from "./PlatinMarketKategori.vue?vue&type=script&lang=js"
import style0 from "./PlatinMarketKategori.vue?vue&type=style&index=0&id=1a574242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a574242",
  null
  
)

export default component.exports